import {CreditCardType} from "../../../types/credit-card"
import {verificationNumberLength} from "../verification-number-length"

export const verificationNumberMask = (type: Nullable<CreditCardType>): string => {
    return '9'.repeat(verificationNumberLength(type))
}
